var AppHelper = (function () {
    function AppHelper() {
    }
    AppHelper.APP_ID = "desk";
    return AppHelper;
}());
export { AppHelper };
